import {
    SonoraEntityType,
    SonoraMeetingTimes,
    SonoraMeetingTimeSuggestion,
} from 'owa-editor-sonora-types';
import { getDateString, owaDate } from 'owa-datetime';
import type { Suggestion } from 'owa-userdataservice';
import { trace } from 'owa-trace';

export default function parseMeetingTimeSuggestions(
    suggestion: Suggestion
): SonoraMeetingTimeSuggestion | undefined {
    try {
        const data = JSON.parse(suggestion.encodedJsonData);
        if (data) {
            // Group timeslots starting on the same day together for rendering.
            const dict = data.reduce((result, userDataInfo) => {
                const start = owaDate(
                    userDataInfo.TimeSlot.Start.TimeZone,
                    userDataInfo.TimeSlot.Start.DateTime
                );
                const end = owaDate(
                    userDataInfo.TimeSlot.End.TimeZone,
                    userDataInfo.TimeSlot.End.DateTime
                );
                const date = getDateString(start);
                if (result[date]) {
                    result[date].timeSlots.push({
                        start: start,
                        end: end,
                    });
                } else {
                    result[date] = <SonoraMeetingTimes>{
                        type: SonoraEntityType.MeetingTimes,
                        date: start,
                        timeSlots: [{ start: start, end: end }],
                    };
                }
                return result;
            }, {});

            return {
                suggestions: Object.values(dict),
                logicalId: suggestion?.logicalId,
                traceId: suggestion?.traceId,
            };
        }
    } catch (error) {
        trace.warn(`[HoneybeeSonora|parseMeetingTimeSuggestion] Error: ${error}`);
    }

    return undefined;
}
